import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillError = ({ fill = '#565B6D' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0011 2C9.32111 2.04 6.77111 3.14 4.89111 5.04C3.00111 6.93 1.96111 9.51 2.00111 12.18C2.00111 17.6 6.39111 22 11.8111 22C11.8111 22 11.8311 22 11.8411 22H12.0111C17.5811 21.95 22.0611 17.4 22.0111 11.83C22.0111 6.41 17.6311 2.01 12.2111 2C12.1411 2 12.0711 2 12.0011 2ZM10.7511 15.78C10.7211 15.1 11.2511 14.53 11.9311 14.5C11.9511 14.5 11.9811 14.5 12.0011 14.5C12.6811 14.5 13.2411 15.04 13.2711 15.72C13.3011 16.4 12.7711 16.97 12.1011 16.99C12.0811 16.99 12.0711 16.99 12.0511 16.99C11.3611 16.99 10.7911 16.46 10.7611 15.77L10.7511 15.78ZM11.1711 12.45V7.45C11.1711 6.99 11.5411 6.62 12.0011 6.62C12.4611 6.62 12.8311 6.99 12.8311 7.45V12.45C12.8311 12.91 12.4611 13.28 12.0011 13.28C11.5411 13.28 11.1711 12.91 11.1711 12.45Z"
      fill={fill}
    />
  </svg>
)

export default withDefaultStyles(FillError)
